import type { SingleOpportunity } from '@ps/web-sports-api-types';

import {
  getIsAvailableOpportunity,
  getIsRestrictedMinOddsOpportunity
} from '@swf/core/models/sports/utils/betSlip/getIsOpportunity';
import type { MarketPollingData } from '@swf/sports/types/market';
import {
  hasMarketStatusChanged,
  hasRunnerHandicapChanged,
  hasRunnerStatusChanged,
  haveOddsChanged
} from '@swf/sports/utils/updateMarket';

const haveMarketsChanged = (
  singles: SingleOpportunity[],
  { data, closed }: MarketPollingData
): boolean => {
  const singleMarketIds = singles.map(({ runnerId }) => runnerId.marketId);
  const hasNewClosedMarkets = closed.some((id) => !singleMarketIds.includes(id));

  if (hasNewClosedMarkets) return true;

  return !!singles.find((opportunity) => {
    const { runnerId, marketStatus } = opportunity;
    const marketUpdate = data[runnerId.marketId];
    const runnerUpdate = marketUpdate?.runners.find(
      (runner) => runner.runnerId.selectionId === runnerId.selectionId
    );

    return (
      hasMarketStatusChanged(marketStatus, marketUpdate?.marketStatus) ||
      hasRunnerStatusChanged(runnerId.runnerStatus, runnerUpdate?.runnerStatus) ||
      (getIsAvailableOpportunity(opportunity) &&
        runnerUpdate &&
        haveOddsChanged(opportunity.winRunnerOdds, runnerUpdate.winRunnerOdds)) ||
      (getIsAvailableOpportunity(opportunity) &&
        hasRunnerHandicapChanged(opportunity.handicap, runnerUpdate?.handicap)) ||
      (getIsRestrictedMinOddsOpportunity(opportunity) &&
        runnerUpdate &&
        haveOddsChanged(opportunity.winRunnerOdds, runnerUpdate.winRunnerOdds))
    );
  });
};

export default haveMarketsChanged;
